import { styled, flexRow, unit, Colors } from '@unfold/theme';

export const ButtonsContainer = styled.div`
  ${flexRow}
  justify-content: space-between;
  padding: ${unit.px(2)} 0;
`;

export const Spinner = styled.div`
  display: inline-block;
  width: 19px;
  height: 19px;

  border: 2px solid ${Colors.G500};
  border-left-color: ${Colors.BLACK};
  border-radius: 50%;

  animation-name: rotate-s-loader;
  animation-iteration-count: infinite;
  animation-duration: 1s;
  animation-timing-function: linear;

  @keyframes rotate-s-loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;